import React from 'react'

const TerraceBanner = () => {
  return (
    <>
      <div className="container-fluild overflow-hidden">
        <section className="nebopan">
          <div
            className="nebopan-banner-section"
            style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/assets/images/maxresdefault-5.png")'}}
          >
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <p className=" centered-p">votre projet terrace</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className="page-banner page">
        <div className="container">
          <div className="d-flex">
            <div className="m-auto">
              <h3 className="title">VOTRE KIT TERRASSE RULLIER SUR MESURE</h3>
            </div>
          </div>
        </div>
      </section>
    </>
  
  )
}

export default TerraceBanner